import { render, staticRenderFns } from "./TaskView.vue?vue&type=template&id=1d3a98e4&scoped=true"
import script from "./TaskView.vue?vue&type=script&lang=js"
export * from "./TaskView.vue?vue&type=script&lang=js"
import style0 from "./TaskView.vue?vue&type=style&index=0&id=1d3a98e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3a98e4",
  null
  
)

export default component.exports